import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { AnimatePresence, motion } from 'framer-motion';

const ConfirmDeleteModal = ({ show, facilityIndex, onCancel, onConfirm, title, message, isLoading = false }) => (
  <AnimatePresence>
    {show && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
        style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1055 }}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="bg-white rounded-4 shadow p-4"
          style={{ maxWidth: '400px', width: '100%' }}
        >
          <h5 className="fw-bold mb-3 text-danger">{title || 'Confirm Deletion'}</h5>
          <p>
            {message || (
              <>
                Are you sure you want to remove{' '}
                <strong>Facility #{facilityIndex + 1}</strong>? This cannot be undone.
              </>
            )}
          </p>
          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="outline-secondary" onClick={onCancel} disabled={isLoading}>
              Cancel
            </Button>
            <Button variant="danger" onClick={onConfirm} disabled={isLoading}>
              {isLoading ? (
                <>
                  <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
                  Removing...
                </>
              ) : (
                'Yes, Remove'
              )}
            </Button>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default ConfirmDeleteModal;
